<template>
  <div class="single-step gdd">
    <div class="heading">
      <div>
        <h2>
          {{ $ml.get(`GDD`) }}
        </h2>
        <info-tip :title="$ml.get(`Growing Degrees Days - The length of the growth stages will be re-calculated based on the local historical temperatures. Increase accuracy of the Fertilization Plan`)" />
      </div>
      <app-btn
        @click="recalculate"
        :loading="loading"
        :disabled="!isFilled"
      >
        {{ $ml.get(`Calculate`) }}
      </app-btn>
    </div>

    <p>{{ $ml.get(`Please insert the values of the GDD needed by your crop in order to re-calculate the stage Duration`) }}</p>

    <p style="color:#EC5A60;" v-if="err"><b>Error: </b>{{ err }}</p>

    <app-loading :loading="is_loading" class="table">

      <app-checkbox
        class="checkbox-gdd"
        style="width: fit-content; width: -moz-fit-content; width: -webkit-fit-content"
        v-model="greenhouse"
        :label="$ml.get(`Greenhouse`)"
        v-if="program.type == 'soil-based'"
      ></app-checkbox>

      <!-- <div class="fields" v-if="program.type == 'soil-based' && !greenhouse"> -->
      <div class="fields">
        <!-- {{ gdd.basalCropTemp }} -->
        <app-text-input
          v-model="basalCropTemp"
          :label="$ml.get(`Basal crop temperature`)"
          type="number"
          hint="C"
          :digits-after-dot="1"
        />
      </div>

      <div class="container">
        <div class="side-fix">
          <div class="item">
            {{ $ml.get(`Stage name`) }}
          </div>
          <div v-for="(stage, i) in stages" class="item" :key="i">
            {{ stage.name }} 
            <info-tip :alert="true" :alerts="alerts[i]"></info-tip>
          </div>

        </div>

        <div>
          <carousel :pageCustom="pageCustom">
            <template>

              <div class="row" >

                <div class="item">
                  {{ $ml.get(`Avg. duration`) }}
                </div>

                <div
                  class="item"
                  v-for="stage in stages"
                  :key="stage.id"
                >

                  {{ stage.data.find(x=>x.key == 'duration').value }}

                </div>

              </div>

              <div
                class="row"
              >

                <div class="item">
                  {{ $ml.get(`GDD Needed by the crop`) }}
                </div>

                <div
                  class="item"
                  v-for="stage in gdd"
                  :key="stage.id"
                >
                  <app-number-input
                    v-model="stage.data.find(x=>x.key == 'gdd').value"
                  />
                </div>

              </div>

              <div
                class="row"
                v-if="program.type != 'soil-based' || greenhouse == true"
              >

                <div class="item">
                  {{ $ml.get(`Avg. temperature `) + $store.getters['unit/getLabel']('C') }}
                </div>

                <div
                  class="item"
                  v-for="stage in gdd"
                >
                  <app-number-input
                    v-model="stage.averageTemp"
                    hint="C"
                  />
                  <!-- {{temp}} -->
                </div>

              </div>




              <div class="row" >

                <div class="item">
                  {{ $ml.get(`New duration based on GDD`) }}
                </div>

                <div
                  class="item"
                  v-for="stage in gdd"
                  :key="stage.id"
                >

                  <app-number-input
                    v-model="stage.data.find(x=>x.key == 'duration').value"
                  />

                </div>

              </div>



            </template>
          </carousel>
        </div>

      </div>
    </app-loading>
    <!-- {{gdd}} -->

  </div>
</template>

<script>
import API from '@/api'
import { mapGetters } from 'vuex'
import Carousel from '@/components/common/carousel/Carousel';

export default {
  data() {
    return {
      err: '',
      loading: false,
      pageCustom: [
        [0, 1],
        [700, 2],
        [800, 3],
        [900, 4],
        [1000, 5],
      ],
      greenhouse: false,
      alerts: []
    }
  },
  methods: {
    async sync() {
      await this.$store.dispatch('program/gdd/loadCropStages', this.$route.params.programId);
      await this.$store.dispatch('program/gdd/loadGdd', this.$route.params.programId);

      if(this.isFilled) await this.recalculate();

      for (var stage of this.gdd) {
        let duration = stage.data.find(x=>x.key == 'duration');
        duration.value = Number(duration.value);
      }

    },
    recalculate() {
      this.loading = true;
      // if(this.greenhouse) this.basalCropTemp = null;
      return API.program.recalculateGdd(this.$route.params.programId, this.gdd, this.basalCropTemp, this.greenhouse)
        .then( res => {
          if(res.data.alerts) {
            this.alerts = []
            res.data.alerts.forEach((e, index )=> {
              if(e.alerts['Basal Crop lower than average temperature at stage'] == true)
                this.alerts[index] = {duration: e.newDuration, alerts: 'Basal Crop temperature is lower than average temperature at stage', id: index}
            })
          }
          this.$store.commit('program/gdd/saveGdd', res.data.data);
          this.loading = false;
          this.finish();
        })
        .catch( err => {
          this.drop();
          this.loading = false;
          this.err = err.response.data.err;
        });
    },
    // checkLocation() {
    //   return API.program.checkGddLocation(this.$route.params.programId)
    //     .then( res => {
    //       this.locationStatus = res.data;
    //     })
    //     .catch( err => {

    //     });
    // },
    finish() {
      // if(obj) {
        // console.log(obj);
        // this.liming = obj;
        this.$store.dispatch('program/steps/setCurrentStep', 'gdd');
        // this.$store.dispatch('program/canGoToNextStep', true);
      // }
    },
    drop() {
      this.$store.dispatch('program/steps/setCurrentStep', 'general-settings')
      // this.$store.dispatch('program/canGoToNextStep', true);
    },
  },
  created() {
    // this.checkLocation();
    this.sync();
    this.greenhouse = (this.program.type != 'soil-based') ? true : false;

  },
  beforeDestroy() {
    this.$store.commit('program/gdd/saveGdd', []);
    this.$store.commit('program/gdd/saveCropStages', []);
    this.$store.commit('program/gdd/saveLoading', true)
    this.$store.commit('program/gdd/saveTemp', [])
  },
  computed: {
    ...mapGetters({
      stages : 'program/gdd/stages',
      gdd: 'program/gdd/gdd',
      is_loading: 'program/gdd/loading',
      program: 'program/data',
      // basalCropTemp: 'program/gdd/temp',
    }),
    basalCropTemp: {
        get () { return this.$store.getters['program/gdd/temp'] },
        set (val) { this.$store.commit('program/gdd/saveTemp' ,val) }
    },
    isFilled () {
      var flag = 0;
      for (var stage of this.gdd) {
        var val = stage.data.find(x=>x.key == 'gdd').value;
        if (val != null && val > 0) {
          flag++
        }
      }

      return this.gdd.length == flag ? true : false;
    }
  },
  components: {
    Carousel,
  }
}
</script>

<style lang="scss" scoped>
.checkbox-gdd {
  width: fit-content;
  width: -moz-fit-content;
}
.heading {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  > div:first-child {
    display: flex;
    flex-direction: row;
    align-items: center;

  }
}
.table {
  padding-top: 20px;
  .fields {
    display: flex;
    margin-bottom: 16px;
    margin-top: 24px;
    width: 300px;
  }
  .container {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: stretch;


    .item {
      height: 64px;
      border-bottom: 1px solid #eee;
      border-right: 1px solid #eee;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
    }

    .side-fix {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      min-width: 200px;

      .item {
        font-size: 13px;
        &:first-child {
          font-weight: bold;
          text-align: center;
        }
      }
    }

    > div:last-child {
      width: calc(100% - 200px);

      .row {
        display: flex;
        flex-direction: column;
        width: 100%;

        .item {
          width: 100%;

          &:first-child {
            font-weight: bold;
            text-align: center;
          }
        }
      }
    }
  }


  // .hor-scroll-shadower {
  //   flex-grow: 1;
  // }

  // .a-table {
  //   width: 100%;

  //   .head {

  //   }
  //   td {
  //     box-sizing: border-box;
  //     padding: 0;
  //     height: 50px;
  //     padding: 0 20px;
  //     min-width: 150px;
  //   }
  // }
  .app-number-input {
    min-width: 100px;
  }
  @media(max-width:768px) {
    .container {
      > div:last-child {
        flex-grow: 1;
      }
      .item {

      }
      .side-fix {
        min-width: unset;
      }
    }
  }
}

</style>
